'use strict';
import template from './mx-grid-actions-panel.component.html';

export class GridActionsPanelController {
	static $inject = ['mx.shell.ActionManagerService', 'mx.internationalization', 'mx.shell.EventService', '$scope'];
	constructor(actionManagerService, i18n, eventService, $scope) {
		this.actionManagerService = actionManagerService;
		this.i18n = i18n;

		eventService.subscribeTo(
			mx.shell.EventCodes.ActionExecuted,
			(e, data) => {
				if (data.parentView === this.view) {
					data.finishPromise.then(() => {
						this.grid.executor.changeSelection([]);
						this.grid.executor.loadItems();
					});
				}
			},
			$scope
		);
	}

	$onInit() {
		this.updateActions();
		this.grid.executor.addSelectionHandler(this.updateActions.bind(this));
		this.view = this.parentViewController?.mxView;
	}

	async updateActions() {
		const selectedItems = this.grid.executor.allSelectedEntities;
		const types = selectedItems.map((item) => item._type);

		const actionContext = new mx.shell.ActionsContext(types, [], mx.shell.ActionUiZone.SidePanel, false);
		let actions = await this.actionManagerService.getActions(actionContext, [mx.shell.ActionContextType.Single, mx.shell.ActionContextType.Multiple], selectedItems);
		this.actions = this.actionManagerService.filterActions(actions, null, selectedItems);

		this.selectedItems = selectedItems;
	}
}

export default {
	bindings: {
		grid: '<',
	},
	require: {
		executorGrid: '^mxExecutorGrid',
		parentViewController: '?^^mxView',
	},
	controller: GridActionsPanelController,
	controllerAs: 'vm',
	template: template,
};
